module.exports = __webpack_public_path__ + "static/media/detail_0026_f.7203bb4d.jpg";